import { render, staticRenderFns } from "./CollectionButton.vue?vue&type=template&id=3b35f0a8&scoped=true"
import script from "./CollectionButton.vue?vue&type=script&lang=js"
export * from "./CollectionButton.vue?vue&type=script&lang=js"
import style0 from "./CollectionButton.vue?vue&type=style&index=0&id=3b35f0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35f0a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
